export const Validation = {
  email(value: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  },

  phone(value: string): boolean {
    return /^\+?[0-9\s\-()]{10,}$/.test(value);
  },

  snils(value: string): boolean {
    const digits = value.replace(/\D/g, '');
    if (digits.length !== 11) return false;
    if (digits === '00000000000') return false;

    const checksum = parseInt(digits.slice(9, 11), 10);
    const sum = digits
      .slice(0, 9)
      .split('')
      .reduce((acc, d, i) => acc + parseInt(d, 10) * (9 - i), 0);

    if (sum < 100 && sum === checksum) return true;
    if ((sum === 100 || sum === 101) && checksum === 0) return true;
    if (sum > 101 && (sum % 101 === checksum || (sum % 101 === 100 && checksum === 0))) {
      return true;
    }

    return false;
  },

  required(value: unknown): boolean {
    if (value === null || value === undefined) return false;
    if (typeof value === 'string') return value.trim().length > 0;
    if (Array.isArray(value)) return value.length > 0;
    return true;
  },

  minLength(value: string, min: number): boolean {
    return value.length >= min;
  },

  maxLength(value: string, max: number): boolean {
    return value.length <= max;
  },

  pattern(value: string, pattern: string | RegExp): boolean {
    const regex = typeof pattern === 'string' ? new RegExp(pattern) : pattern;
    return regex.test(value);
  },

  inn(value: string): boolean {
    const digits = value.replace(/\D/g, '');
    if (digits.length !== 10 && digits.length !== 12) return false;

    const weights10 = [2, 4, 10, 3, 5, 9, 4, 6, 8];
    const weights12_1 = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8];
    const weights12_2 = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8];

    if (digits.length === 10) {
      const sum = digits
        .slice(0, 9)
        .split('')
        .reduce((acc, d, i) => acc + parseInt(d, 10) * weights10[i]!, 0);
      return (sum % 11) % 10 === parseInt(digits[9]!, 10);
    }

    const sum1 = digits
      .slice(0, 10)
      .split('')
      .reduce((acc, d, i) => acc + parseInt(d, 10) * weights12_1[i]!, 0);
    const sum2 = digits
      .slice(0, 11)
      .split('')
      .reduce((acc, d, i) => acc + parseInt(d, 10) * weights12_2[i]!, 0);

    return (
      (sum1 % 11) % 10 === parseInt(digits[10]!, 10) &&
      (sum2 % 11) % 10 === parseInt(digits[11]!, 10)
    );
  },
};
